<div class="config-loading" *ngIf="!loaded">
    <div class="k-i-loading"></div>
</div>

<section class="config-section" *ngIf="loaded">
    <h3 class="config-section-title">Protected Buckets That Affect Capacity</h3>

    <div class="config-warning">
        <span class="k-icon k-i-warning"></span>
        <div>
            <strong>Switching a bucket on changes how much capacity the optimizer thinks it has.</strong>
            <p>
                A bucket switched on has its unsold allocation subtracted from remaining leg
                capacity. The subtraction is per origin&ndash;destination pair and is
                <em>summed across every OD that runs over a leg</em>, so a bucket whose limits
                are set network-wide is multiplied by the number of ODs on the leg rather than
                applied once. In testing, four buckets holding blanket limits of 10, 10, 10 and 5
                on nearly every OD removed roughly 640 seats from a 124-seat leg and left 83% of
                legs with no capacity to sell.
            </p>
            <p>
                Only switch on buckets whose limits are set deliberately, for specific ODs.
                Check the bucket's limits first. Changes take effect on the next overnight run.
            </p>
        </div>
    </div>

    <p class="config-counter config-note" *ngIf="!protectedBucketsConfigSaved">
        Nothing has been saved here yet, so the overnight run is still using the value from
        its settings file. The switches below show no buckets enabled, which is not
        necessarily what is in force &mdash; saving will replace it.
    </p>

    <p class="config-counter config-note" *ngIf="!protectedBucketsLoaded">
        Could not load the list of protected buckets. Saving will leave this setting untouched.
    </p>

    <div class="config-bucket-list" *ngIf="protectedBucketsLoaded">
        <div class="config-setting" *ngFor="let row of protectedBucketRows">
            <label class="config-label">{{ row.bucketCode }}</label>
            <kendo-switch [(ngModel)]="row.affectsCapacity"
                          [name]="'affects-' + row.bucketCode"></kendo-switch>
            <label class="config-counter">{{ row.paxClass }}</label>
        </div>
    </div>

    <p class="config-counter config-note config-note-warn" *ngIf="anyProtectedBucketEnabled">
        Capacity will be reduced on every leg these buckets apply to from the next
        overnight run.
    </p>
</section>

<div class="config-actions" *ngIf="loaded">
    <button kendoButton [primary]="true" [disabled]="!protectedBucketsLoaded || saving" (click)="onSave()">
        <span *ngIf="saving" class="k-i-loading saving-icon"></span>{{ saving ? 'Saving...' : 'Save' }}
    </button>
</div>
